import React from 'react';

export const PdfIcon = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 2C0 0.90625 0.875 0 2 0H7V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2ZM12 4H8V0L12 4Z"
      fill="#737373"
    />
  </svg>
);
